import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/quality-assurance/annual-product-review-apr-product-quality-review-pqr")({
  beforeLoad: () => { throw redirect({ to: "/zh-cn/services/quality-assurance/qa-consultancy-apr-pqr", statusCode: 301 }); },
});
